import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, People } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import { createUser, deleteUser, fetchUsers, updateUser } from '../../data/slices/userSlice';
import User, { UserCreation } from '../../data/schemas/user';
import PageHeader from '../../components/layout/PageHeader';

const UserPage = (props) => {
    const { users } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    const [user, setUser] = useState(null);
    const [open, setOpen] = useState(false);

    const addUser = (data, clearForm) => {
        setOpen(false);
        if (!data.id) {
            createUser(data, (err) => output(err), (resp) => {
                clearForm();
                notify("L'utilisateur a été ajouté avec succès !");
                dispatch(fetchUsers());
            });
        } else {
            updateUser(data, (err) => output(err), (resp) => {
                clearForm();
                notify("L'utilisateur a été enregistré avec succès !");
                dispatch(fetchUsers());
            });
        }
    }

    const onUserSelected = (id) => {
        setUser(users.find((user) => user.id === id));
        setOpen(true);
    }

    const onDelete = (id) => {
        setOpen(false);
        deleteUser(id, (err) => output(err), (resp) => {
            setUser(null);
            notify("L'utilisateur a bien été supprimé !");
            dispatch(fetchUsers());
        });
    }

    const handleClose = () => {
        setOpen(false);
        setUser(null);
    }

    useEffect(() => {
        dispatch(fetchUsers());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion des Utilisateurs"
                subtitle="Gérez les comptes et les accès de votre équipe"
                icon={People}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Utilisateurs', path: '/parametres/users' }
                ]}
                actions={[
                    { 
                        label: 'Ajouter un utilisateur', 
                        icon: <Add />, 
                        onClick: () => { setUser(null); setOpen(true); },
                        color: 'primary'
                    }
                ]}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des membres ({users.length})
                    </Typography>
                </Box>
                
                <StyledTable
                    rows={[...users].sort((a,b) => sortByProp(a, b, 'nomComplet'))}
                    head={Object.keys(new User())}
                    onOptionClicked={onUserSelected}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform 
                    onSubmit={addUser}
                    mandatories={["nomComplet", "password", "code", "username"]}
                    entity={new UserCreation()}
                    toUpdate={user}
                    onDelete={onDelete}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default UserPage;
